<template>
  <div class="table_side-create mb-12">
    <div class="table_side-content">
      <smsc-col>
        <smsc-col-item class="col-md-12">
          <vs-input
            v-validate="'required'"
            name="first name"
            class="w-100 p-4 table-side-input"
            :class="{'is-danger': errors.has('template')}"
            type="text"
            label="Template"
            placeholder="Type a name of Template"
            v-model="payload.template_name"
          />
          <span class="text-danger text-xs  p-4">{{ errors.first('template') }}</span>
        </smsc-col-item>
      </smsc-col>
      <smsc-col>
        <smsc-col-item>
          <div class="smsc-box__item p-4 table-side-input">
            <span class="mr-6 text-sms">SMS TEXT</span>
            <vs-textarea
              placeholder="Enter sms text"
              v-model="payload.sms_text"
            />
          </div>
        </smsc-col-item>
      </smsc-col>
      <smsc-col>
        <smsc-col-item>
          <div class="smsc-box__item p-4 table-side-input">
            Available Tags: {{ payload.template_name }}  {{ payload.sms_text }}
          </div>
        </smsc-col-item>
      </smsc-col>
      <div class="buttons-container flex flex-wrap items-center justify-end pb-3 right-btn">
        <vs-button
          @click="addSmSTemplate"
          class="mt-3"
        >Add SMS</vs-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Add",
  data() {
    return {
      payload: {
        template_name: '',
        sms_text: '',
      }
    }
  },
  methods: {
    addSmSTemplate(){
      this.$store.dispatch('smsTemplate/Add',{...this.payload})
      .then((res) => {
        if(res.success){
          console.log(res)
          this.ShowSuccessMessage({ title: 'Success', text: 'SMS Template has been added' })
          this.$router.push({ name: 'company-admin-template-sms-list' })
        }
      }).catch(err => this.ShowErrorMessage({ title: 'Error', text: err }))
        .finally(() => this.$vs.loading.close())
    },
    // Notify
    ShowSuccessMessage ({ title, text }) {
      this.$vs.notify({
        iconPack: 'feather',
        icon: 'icon-check',
        color: 'success',
        title,
        text
      })
    },
    ShowErrorMessage ({ title, text }) {
      this.$vs.notify({
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger',
        title,
        text
      })
    },
  }
}
</script>
<style scoped lang="scss">
.table_side-create {
  background: white;
  .table_side-content {
    padding: 25px;
  }
  .table-side-input {
    width: 300% !important;
  }
  .text-sms {
    font-size: .85rem;
    color: rgba(0,0,0,.7);
  }
  .right-btn {
    margin-right: 4.25rem;
  }
}
</style>
